import { useEffect, useRef, useState } from "react";
import Events from "./event-cards/Events";
import EventInfoContainer from "./event-info/EventInfoContainer";
import EventInfoContainerSheet from "./event-info/EventInfoContainerSheet";
import EventFilter from "./filter/EventFilter";
import EventFilterSheet from "./filter/EventFilterSheet";
import { useSearchParams } from "react-router-dom";
import { cn, extractCategories, extractEventName, filterSuggestedResults, findEventDate } from "@/lib/utils";
import ContextProvider from "./context/ContextProvider";
import { useGetUnreviewedSocialPosts } from "./api/unreviewed-api";
import { format, subDays } from "date-fns";
import { DateRange } from "react-day-picker";

export type SuggestedPostFilterType = {
  name: string;
  startDate: Date | undefined;
  endDate: Date | undefined;
  type: string | undefined;
  event_category: string[];
  isFilter: boolean
}


const UnreviewedTab = () => {

  const [date, setDate] = useState<DateRange | undefined>({
    from: subDays(new Date(), 7),
    to: new Date(),
  })

  const [page, setPage] = useState(1)


  const { socialPosts, isLoading } = useGetUnreviewedSocialPosts(page, date?.from ? format(date.from, "yyyy-MM-dd") : format(subDays(new Date(), 20), "yyyy-MM-dd"),
    date?.to ? format(date.to, "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd"))


  const [searchParams,] = useSearchParams();
  const eventName = searchParams.get("event")

  const [filter, setFilter] = useState<SuggestedPostFilterType>({ name: eventName ? eventName : "", startDate: undefined, endDate: undefined, type: undefined, event_category: [], isFilter: false })


  const containerRef = useRef<HTMLDivElement | null>(null);
  const initialRef = useRef(true);

  const [viewId, setViewId] = useState(socialPosts ? socialPosts.data[0]?.event : "");
  const [selected, setSelected] = useState("");
  const [tabClicked, setTabClicked] = useState(false)


  useEffect(() => {
    setSelected(viewId);
  }, [viewId]);

  const viewChangeHandler = (id: string) => {
    if (initialRef.current) return;
    if (tabClicked) return;
    setViewId(id);
  };

  const schedulePostTabChangeHandler = (id: number) => {
    console.log("running")
    if (socialPosts) {
      console.log("running")
      setViewId(socialPosts.data[id].event)
    }

  }

  const setChangeTabHandler = (id: string) => {
    setTabClicked(true)
    setViewId(id)
    const container = containerRef.current;
    const targetElement = document.getElementById(id);
    if (container && targetElement) {
      const containerRect = container.getBoundingClientRect();
      const targetRect = targetElement.getBoundingClientRect();
      const scrollAmount = targetRect.top - containerRect.top;

      container.scrollTo({
        top: container.scrollTop + scrollAmount,
        behavior: "smooth",
      });
      setTabClicked(false)
    }
  };


  return (
    <ContextProvider>
      <div className="mt-4 h-[75vh] overflow-auto p-4 size-full " ref={containerRef}>
        <div className="flex items-center relative justify-center gap-2 w-full py-4" >
          <div className="fixed bottom-4 left-2 sm:left-16 z-40 flex flex-col gap-2 justify-between px-4 items-center">
            <EventFilterSheet
              date={date}
              setDateFilter={setDate}
              filter={filter} setFilter={setFilter}
              categories={socialPosts ? extractCategories(socialPosts.data) : []}
            />
            <EventInfoContainerSheet
              date={findEventDate(socialPosts ? socialPosts.data : [], selected)}
              setSelected={setChangeTabHandler} selected={selected}
              eventsList={extractEventName(filterSuggestedResults(filter, socialPosts ? socialPosts.data : []))}
            />
          </div>
          <div className={cn("hidden lg:block",
            socialPosts && socialPosts.data.length === 0 && page === 1 && "invisible")}>
            <EventFilter
              date={date}
              setDateFilter={setDate}
              filter={filter}
              setFilter={setFilter}
              categories={socialPosts ? extractCategories(socialPosts.data) : []}
            />
          </div>
          {socialPosts && (
            <Events
              page={page}
              container={containerRef}
              onInView={viewChangeHandler}
              setPage={setPage}
              isInitial={initialRef}
              eventsData={filterSuggestedResults(filter, socialPosts ? socialPosts.data : [])} isLoading={isLoading}
              onSchedule={schedulePostTabChangeHandler}
            />
          )}
          {socialPosts && socialPosts.data.length === 0 && page === 1 && (
            <p>No posts found</p>
          )}
          <div className={cn("hidden lg:block",
            socialPosts && socialPosts.data.length === 0 && page === 1 && "invisible")}>
            <EventInfoContainer
              date={findEventDate(socialPosts ? socialPosts.data : [], selected)}
              setSelected={setChangeTabHandler}
              selected={selected}
              eventsList={extractEventName(filterSuggestedResults(filter, socialPosts ? socialPosts.data : []))} />
          </div>
        </div>
      </div>
    </ContextProvider>
  )
}

export default UnreviewedTab;
